
export class GetPaginatedFavorites {
  static readonly type = '[Favorites] - Get Paginated favorites';

  constructor(public limit: number, public offset: number) {}
}

export class PostFavorite {
  static readonly type = '[Favorites] - Post favorite';

  constructor(public favoriteId: string) {}
}

export class DeleteFavorite {
  static readonly type = '[Favorites] - Delete favorite';

  constructor(public favoriteId: string) {}
}

export class DeleteAllFavorite {
  static readonly type = '[Favorites] - Delete all favorites';
}